
import { get, post, put } from "../services/HttpService";
import { axiosIns } from "../services";


export class TallyInvoice {
    constructor(tallyInvoiceObject = {}) {
        this.set(tallyInvoiceObject);
    };

    /**
     * @memberof TallyInvoice
     * @type API
     * @returns Promise
     */
    static list = (queryData = {}, config = {}) => {
        return get(`v1/internal/tally_invoices/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof TallyInvoice
     * @type API
     * @returns Promise
     */
    initiate = (queryData = {}) => {
        queryData = { ...queryData, ...this.get() };
        return post(`v1/internal/initiate_tally_invoices_transfer/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof PayoutLink
     * @type API
     * @returns Promise
     */
     fetchAttempts = (queryData = {}) => {
        return get(`v1/internal/tally_invoices/${this.id}/attempts/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof TallyInvoice
     * @type API
     * @returns Promise
     */
     static download_report = (queryData = {}, config = {}) => {
        return axiosIns.request({
            url: 'v1/internal/tally_invoices/download_report/',
            method: 'POST',
            responseType: 'blob',
            data: queryData,
            headers: config.headers
        }).catch(error => ({ success: false, data: "Something went wrong", status: 500 }))
    }

    /**
     * @memberof TallyInvoice
     * @type Setter Method
     * @takes TallyInvoice Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };

    /**
     * @memberof TallyInvoice
     * @type Getter Method
     * @returns TallyInvoice
     */
    get = () => {
        return {
            id: this.id,
            uuid: this.uuid,
            merchant: this.merchant,
            invoice_number: this.invoice_number,
            beneficiary_account_name: this.beneficiary_account_name,
            beneficiary_account_number: this.beneficiary_account_number,
            beneficiary_account_ifsc: this.beneficiary_account_ifsc,
            payment_mode: this.payment_mode,
            total_amount: this.total_amount,
            pending_amount: this.pending_amount,
            due_date: this.due_date,
            invoice_date: this.invoice_date,
            tally_uuid: this.tally_uuid,
            status: this.status,
        }
    };
}